import { render, staticRenderFns } from "./widget-element-row.vue?vue&type=template&id=6499c0dd&scoped=true"
import script from "./widget-element-row.vue?vue&type=script&lang=js"
export * from "./widget-element-row.vue?vue&type=script&lang=js"
import style0 from "./widget-element-row.vue?vue&type=style&index=0&id=6499c0dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6499c0dd",
  null
  
)

export default component.exports